<template>
  <div class="countdown">
    <div v-if="current <= 10" style="padding:5px">Signing-out in {{ current }} seconds&hellip;</div>
  </div>
</template>

<script>
import * as moment from 'moment'

export default {
  props: ['interval'],
  data () {
    return {
      current: this.interval
    }
  },
  mounted () {
    window.setInterval(() => this.tickTock(), 1000);
    window.document.body.addEventListener('mousemove', () => {
      this.current = this.interval;
      window.document.title = 'Pan Essex';
    });
  },
  computed: {
    currentHuman () {
      return moment.duration(this.current, 'seconds').humanize();
    }
  },
  methods: {
    tickTock () {
      // don't go further than zero
      if (this.current <= 0) {
        return;
      }
      // decrement
      this.current = this.current - 1
      if (this.current < this.interval - 10) {
        window.document.title = `Pan Essex: ${this.current}s until logout`;
      }
      // reset time
      if (this.current <= 0) {
        this.$emit('zero')
      }
    }
  }
}
</script>

<style lang="scss">
.countdown {
  background-color: lighten(rgb(120, 0, 156), 5%);
  color: #fff;
  margin: 20px 0;
  position: absolute;
  top: 40px;
  right: 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
</style>
